import { CASE_ALERT_STATUS_LABELS } from "src/constants/cases";
import { useT } from "src/internationalization";
import { CaseAlertStatus } from "src/types/case";

export const useGetCaseAlertStatusLabel = () => {
  const t = useT();

  const getCaseAlertStatusLabel = (status: CaseAlertStatus) => {
    return t(CASE_ALERT_STATUS_LABELS[status]);
  };

  return getCaseAlertStatusLabel;
};
